import React, { FC, useRef, useEffect, useCallback } from 'react';

type Props = {
  onOutsideClick: Function;
  className?: string;
};

export const OutsideFocusHandler: FC<Props> = ({
  onOutsideClick,
  className,
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: Event) => {
      if (
        wrapperRef.current &&
        event.target instanceof Element &&
        !wrapperRef.current.contains(event.target)
      ) {
        onOutsideClick(event);
      }
    },
    [onOutsideClick],
  );

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div className={className} ref={wrapperRef}>
      {children}
    </div>
  );
};
